import React, { useState, useEffect } from "react";
import {
  Button,
  Icon,
  Confirm,
  Grid,
  GridRow,
  GridColumn,
  List,
  ListColumn,
  ListItem,
  ListContent,
  Checkbox,
  Segment,
  Header,
  Divider,
  SegmentGroup,
  Dropdown,
  Form,
  FormButton,
  Card,
  Accordion,
} from "semantic-ui-react";
import { Permission, Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useFormik } from "formik";
import { BasicModal, ConfirmModal } from "../../../Shared";
// import { PermissionForm } from "../PermissionForm";
import {
  convertModulesEngToEsp,
  convertActionsEngToEsp,
} from "../../../../utils/converts";
import { MODULES } from "../../../../utils/constants";
import "./PermissionsRole.scss";
import { useLanguage } from "../../../../contexts";
import { hasPermission, isAdmin, isMaster } from "../../../../utils/checkPermission";

const permissionController = new Permission();
const roleController = new Role();

// export function PermissionsRole(props) {
//   const { role, onReload } = props;
//   const { accessToken } = useAuth();

//   const { language, changeLanguage, translations } = useLanguage();
  
//   const t = (key) => translations[key] || key ; // Función para obtener la traducción

//   const [listPermissions, setListPermissions] = useState([]);
//   const [listPermissionsFilter, setListPermissionsFilter] = useState([]);
//   const [moduleData, setModuleData] = useState("users");

//   useEffect(() => {
//     if (role) {
//       permissionController
//         .getPermissionsByRoleId(accessToken, role._id)
//         .then((response) => {
//           if (response) {
//             setListPermissions(response);
//             // const info = Object.keys(result);
//             // setModules(info);
//           } else {
//             setListPermissions([]);
//           }
//           //  console.log(listPermissions)
//         });
//     }
//   }, [role]);

//   useEffect(() => {
//     if (moduleData !== "" && listPermissions) {
//       //Agrupa por modulo
//       const result = listPermissions.filter((i) => i.module === moduleData);
//       setListPermissionsFilter(result);
//     }
//   }, [moduleData, listPermissions]);

//   const [showModal, setShowModal] = useState(false);
//   const [titleModal, setTitleModal] = useState("");

//   const [showConfirm, setShowConfirm] = useState(false);
//   const [confirmMessage, setConfirmMessage] = useState("");
//   const [isDelete, setIsDelete] = useState(false);

//   const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
//   const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

//   const openUpdatePermission = (permission) => {
//     setTitleModal(`${t("update")} ${permission.action}`);
//     onOpenCloseModal();
//   };

//   const openDesactivateActivateConfim = (permission) => {
//     setIsDelete(false);
//     setConfirmMessage(
//       permission.active
//         ? `${"deactivate"} ${permission.action}`
//         : `${"activate"} ${permission.action}`
//     );
//     onOpenCloseConfirm();
//   };

//   const onActivateDesactivate = async (permission) => {
//     try {
//       await permissionController.updatePermission(accessToken, permission._id, {
//         active: permission.active,
//       });
//       // setOnReloadModal(!onReloadModal);
//       //onOpenCloseConfirm();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const confirmData = (e) => {
//     listPermissionsFilter.map(async (i) => {
//       return await onActivateDesactivate(i);
//       // // setOnReloadModal(!onReloadModal);
//     });
//     onReload();
//     //onOpenCloseConfirm();
//   };

//   const setActivateDesactivate = (checked, index) => {
//     const newData = [...listPermissionsFilter];
//     newData[index].active = checked;
//     setListPermissionsFilter(newData);
//   };

//   const openDeleteConfirm = (permission) => {
//     setIsDelete(true);
//     setConfirmMessage(`${t("delete")} ${permission.action}`);
//     onOpenCloseConfirm();
//   };

//   const onDelete = async (permission) => {
//     try {
//       await permissionController.deletePermission(accessToken, permission._id);
//       onReload();
//       onOpenCloseConfirm();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <>
//       <Form onSubmit={confirmData}>
//         <div className="permissions-role-item">
//           <div className="permissions-role-item__info">
//             <div>
//               <Divider horizontal>
//                 <Header as="h4">{t("module")}</Header>
//               </Divider>
//               <Dropdown
//                 label={t("module")}
//                 // placeholder="Selecciona un modulo"
//                 options={MODULES.map((ds) => {
//                   return {
//                     key: ds,
//                     text: t(ds),
//                     value: ds,
//                   };
//                 })}
//                 selection
//                 onChange={(_, data) => setModuleData(data.value)}
//                 value={moduleData}
//               />
//             </div>
//           </div>
//           {listPermissionsFilter && listPermissionsFilter.length >= 0 ? (
//             <div className="permissions-role-item__">
//               <Divider horizontal>
//                 <Header as="h4">
//                   {/* <Icon name='tag' /> */}
//                   {t("permissions")}
//                 </Header>
//               </Divider>
//                 {listPermissionsFilter.map((permission, index) => {
//                   return (
//                     <div>
//                       <Grid celled>
//                         <GridRow>
//                           <GridColumn width={2}>
//                             <Icon name={actionIcon(permission.action)} />
//                           </GridColumn>
//                           <GridColumn width={5}>
//                             {t(permission.action)}
//                           </GridColumn>
//                           <GridColumn width={3}>
//                             <Checkbox
//                               toggle
//                               checked={permission.active}
//                               label={permission.active? t("enabled") : t("disabled")}
//                               onChange={(e, { checked }) => {
//                                 setActivateDesactivate(checked, index);
//                               }}
//                             />
//                           </GridColumn>
//                         </GridRow>
//                       </Grid>
//                     </div>
//                   );
//                   //   </ListContent>
//                   // </ListItem>
//                 })}
//               {/* </List> */}
//               {/* </List> */}
//               {/* <div>
//             <Grid divided="vertically" celled='internally'>
//               <GridRow >
//                 <GridColumn width={6}>
//                   <p>{role}</p>
//                 </GridColumn>
//                 <GridColumn width={6}>
//                   <p>{convertModulesEngToEsp(permission.module)}</p>
//                 </GridColumn>
//                 <GridColumn>
//                   <p>{convertActionsEngToEsp(permission.action)}</p>
//                 </GridColumn>
//               </GridRow>
//             </Grid>
//           </div> */}
//             </div>
//           ) : null}
//           {/* <div>
//           <Button icon primary onClick={openUpdateUser}>
//             <Icon name="pencil" />
//           </Button>
//           <Button
//             icon
//             color={permission.active ? "orange" : "teal"}
//             onClick={openDesactivateActivateConfim}
//           >
//             <Icon name={permission.active ? "ban" : "check"} />
//           </Button>
//           <Button icon color="red" onClick={openDeleteConfirm}>
//             <Icon name="trash" />
//           </Button>
//         </div> */}
//         </div>

//         <div>
//           <FormButton type="submit" primary content={t("save")} />
//         </div>

//         <Confirm
//           open={showConfirm}
//           onCancel={onOpenCloseConfirm}
//           onConfirm={isDelete ? onDelete : onActivateDesactivate}
//           content={confirmMessage}
//           size="mini"
//         />
//       </Form>
//     </>
//   );
// }


// Ejemplo de módulos
//const MODULES = ["users", "permissions", "reports"]; 

// Función para determinar icono según acción
// const actionIcon = (action) => {
//   switch (action) {
//     case "create":
//       return "plus";
//     case "edit":
//       return "pencil";
//     case "delete":
//       return "trash";
//     case "view":
//       return "eye";
//     default:
//       return "circle";
//   }
// };

export function PermissionsRole({ role, roleUser, permissionsByRole, t, onReload }) {
  const { accessToken } = useAuth();

  const [active, setActive] = useState(false);
  const [listPermissions, setListPermissions] = useState([]);
  const [listPermissionsFilter, setListPermissionsFilter] = useState([]);
  const [moduleData, setModuleData] = useState(MODULES[0]);

  const canEdit = isMaster(roleUser) || isAdmin(roleUser) || hasPermission(permissionsByRole, roleUser._id, "permissions", "edit");

  useEffect(() => {
    if (role) {
      permissionController
        .getPermissionsByRoleId(accessToken, role._id)
        .then((response) => setListPermissions(response || []));
    }
  }, [role]);

  useEffect(() => {
    if (moduleData && listPermissions) {
      setListPermissionsFilter(listPermissions.filter((p) => p.module === moduleData));
    }
  }, [moduleData, listPermissions]);

  const setActivateDesactivate = (checked, index) => {
    const newData = [...listPermissionsFilter];
    newData[index].active = checked;
    setListPermissionsFilter(newData);
  };

  const saveChanges = async () => {
    for (const permission of listPermissionsFilter) {
      await permissionController.updatePermission(accessToken, permission._id, {
        active: permission.active,
      });
    }
    onReload();
  };

  const handleAccordionClick = () => setActive(!active);

  return (
    <Accordion styled fluid>
        <Accordion.Title active={active} onClick={handleAccordionClick} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", minHeight:"50px" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <Icon name="dropdown" />
      {t(role.name.toLowerCase())}
    </div>

    {canEdit && (
      <Icon 
        name="pencil" 
        style={{ cursor: "pointer", color:"#2185d0" }}
        onClick={(e) => {
          e.stopPropagation(); // evita que se abra/cierre el acordeón al hacer clic en el lápiz
          // Aquí podrías abrir un modal o simplemente enfocar el dropdown de módulos
        }}
      />
    )}
  </Accordion.Title>
      <Accordion.Content active={active}
       style={{ minHeight: "250px", padding: "1rem" }} // <- Ajuste de altura y padding
      >
        <Divider horizontal>
          <Header as="h4">{t("module")}</Header>
        </Divider>
        <Dropdown
          selection
          options={MODULES.map((m) => ({ key: m, text: t(m), value: m }))}
          value={moduleData}
          onChange={(_, data) => setModuleData(data.value)}
        />

        <Divider horizontal>
          <Header as="h4">{t("permissions")}</Header>
        </Divider>

        {listPermissionsFilter.map((permission, index) => (
          <Grid celled key={permission._id}>
            <GridRow>
              <GridColumn width={2}>
                <Icon name={actionIcon(permission.action)} />
              </GridColumn>
              <GridColumn width={5}>{t(permission.action)}</GridColumn>
              <GridColumn width={3}>
                <Checkbox
                  toggle
                  checked={permission.active}
                  label={permission.active ? t("enabled") : t("disabled")}
                  disabled={!canEdit}
                  onChange={(e, { checked }) =>
                    setActivateDesactivate(checked, index)
                  }
                />
              </GridColumn>
            </GridRow>
          </Grid>
        ))}

      {canEdit && (
  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
    <Button primary onClick={saveChanges} content={t("save")} 
    // icon="check" labelPosition="right"
     />
  </div>
)}
      </Accordion.Content>
    </Accordion>
  );
}


// function PermissionRoleItem(props) {
//   const { module, permissions, listPermissions, setListPermissions } = props;

//   const setActivateDesactivate = (checked, index) => {
//     const newData = { ...listPermissions };
//     newData[module][index].active = checked;
//     setListPermissions(newData);
//   };

//   return permissions.map((permission, index) => {
//     return (
//       <div>
//         <Grid divided="vertically" celled="internally">
//           <GridRow>
//           <GridColumn>
//           <Icon name={actionIcon(permission.action)} />
//           </GridColumn>
//             <GridColumn width={10}>
//               <p>{convertActionsEngToEsp(permission.action)}</p>
//             </GridColumn>
//             <GridColumn width={4}>
//               <Checkbox
//                 toggle
//                 checked={permission.active}
//                 onChange={(e) => {
//                   setActivateDesactivate(e.checked, index);
//                 }}
//               />
//             </GridColumn>
//           </GridRow>
//         </Grid>
//       </div>
//     );
//   });
// }

function actionIcon(a) {
  switch (a) {
    case "edit":
      return "edit";
    case "delete":
      return "trash alternate outline";
    case "create":
      return "add circle";
    case "update":
      return "pencil alternate";
    case "view":
      return "eye";
    case "menu":
      return "th list";
    default:
      return null;
  }
}
